<script>
import KSPagination from "../../component/ks-table/KSPagination.vue";
import UserPromoApi from "../../api/UserPromoApi";
import PartnerCreatePromo from "./component/CreatePromo.vue";
import {Listeners} from "../../constants/listeners";
import Button from "primevue/button";
import Alerts from "../../mixins/Alerts";
import Clipboard from "../../mixins/Clipboard";

export default {
    mixins: [Alerts, Clipboard],
    data() {
        return {
            loading: false,
            page: 1,
            data: [],
            notifyParams: {
                timeout: 2000,
                showProgressBar: false,
            }
        }
    },
    mounted() {
        this.loadPromocodes();
    },
    methods: {
        loadPromocodes(page = 1) {
            let self = this;
            if (page === 'next') {
                page = this.page + 1
            }
            if (page === 'prev') {
                page = this.page - 1
            }
            if ((page > 1 && this.$refs.pagination.totalPage < page) || page < 1) {
                return;
            }
            this.page = page;
            this.loading = true;
            UserPromoApi.getAll(page)
                .then(response => {
                    self.data = response.data;
                    self.$refs.pagination.setPaginationData({
                        current_page: response.current_page,
                        last_page: response.last_page
                    })
                })
                .catch(e => this.alertError((e)))
                .finally(() => this.loading = false);
        },
        getStatusLabel(status) {
            return status === 1 ? this.$t('lang.promocode.active_label') : this.$t('lang.promocode.no_active_label');
        },
        showCreateModal() {
            this.$emitter.emit(Listeners.POPUP_PARTNER_CREATE_PROMO_OPEN);
        },
        changeStatus(event) {
            let data = event.target.getAttribute('data-code');
            let self = this;
            this.loading = true;
            UserPromoApi.changeStatus(data)
                .then(() => {
                    this.loading = false;
                    self.$snotify.info(self.$t('lang.promocode.switch_status_success'), self.notifyParams);
                    this.loadPromocodes(this.page);
                })
                .catch((error) => {
                    this.loading = false;
                    self.$snotify.error(error.message, self.notifyParams);
                })
        },
        _copy(event) {
            let data = event.target.getAttribute('data-code');
            this.copyToClipboard(data);
        },
    },
    computed: {
        showTable() {
            return this.data && this.data.length > 0;
        },
    },
    components: {
        PartnerCreatePromo,
        "ks-pagination": KSPagination,
        Button,
    },
}
</script>

<template>
    <div class="width user_promocode__container tablereports mb-3">
        <template v-if="loading">
            <div id="ks-preloader">
                <div id="ks-loader"></div>
            </div>
        </template>
        <div class="flex flex-column sm:flex-row align-items-center justify-content-between gap-2 mb-3">
            <span class="user_promocode__title font-bold text-lg flex-order-1 align-self-start sm:align-self-auto">{{ $t('lang.promocode.main_label') }}</span>
            <Button
                @click="showCreateModal"
                outlined
                class="flex-order-0 sm:flex-order-2 align-self-end sm:align-self-auto"
                icon="pi pi-plus"
                :label="$t('lang.promocode.create_new_promocode')"
            />
        </div>
        <div v-show="showTable" class="overflow-x-auto">
            <table class="user_promocode__table">
                <thead>
                    <tr>
                        <th class="text-left bg-primary" style="width: 200px">
                            <span class="bg-primary" style="margin-left: 26px;">{{ $t('lang.promocode.t_code') }}</span>
                        </th>
                        <th class="text-center bg-primary">{{ $t('lang.promocode.t_activation_number') }}</th>
                        <th class="text-center bg-primary">{{ $t('lang.promocode.t_partner_earnings') }}</th>
                        <th class="text-center bg-primary">{{ $t('lang.promocode.t_partner_freeze') }}</th>
                        <th class="text-center bg-primary">{{ $t('lang.promocode.t_create_date') }}</th>
                        <th class="text-center bg-primary">{{ $t('lang.promocode.t_percent') }}</th>
                        <th class="text-center bg-primary">{{ $t('lang.promocode.t_discount') }}</th>
                        <th class="text-left bg-primary">{{ $t('lang.promocode.t_status') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data">
                        <td class="text-left">
                            <div class="flex align-items-center flex-nowrap">
                                <i class="pi pi-clone" :data-code="item.code" @click="_copy"></i>
                                <span>{{ item.code }}</span>
                            </div>
                        </td>
                        <td class="text-center">{{ item.used_times }}</td>
                        <td class="text-center">{{ item.partner_amount.formatMoney(0, ' ', ' ') }} &#8381;</td>
                        <td class="text-center">{{ item.partner_freeze.formatMoney(0, ' ', ' ') }} &#8381;</td>
                        <td class="text-center">{{ item.created_at }}</td>
                        <td class="text-center">{{ item.percent }} %</td>
                        <td class="text-center">{{ item.discount }} %</td>
                        <td v-html="getStatusLabel(item.status)" class="clickable" :class="{active: item.status === 1}" @click="changeStatus" :data-code="item.code" ></td>
                    </tr>
                </tbody>
            </table>
            <div class="pagination-row">
                <ks-pagination
                    ref="pagination"
                    :on-each-side="2"
                    @vuetable-pagination:change-page="loadPromocodes"></ks-pagination>
            </div>
        </div>
        <div class="not-found" v-show="!showTable && !loading">{{ $t('lang.promocode.not_found') }}</div>
        <PartnerCreatePromo />
    </div>
</template>

<style scoped>
.user_promocode__title {
    color: #33404D;
}
.user_promocode__table {
    border-collapse: collapse;
    width: 100%;
}
.user_promocode__table tr:nth-child(even) {
    background: var(--keysso-table-even-row-background);
}
.user_promocode__table th {
    font-size: 13px;
    font-weight: 500;
    padding: 8px 6px;
}
.user_promocode__table td {
    padding: 8px 6px;
    font-size: 13px;
}
.not-found {
    text-align: center;
    padding: 10px 0 0 0;
    font-size: 14px;
}
.pagination-row {
    padding: 0 10px;
    margin: 16px 0;
}
.clickable {
    cursor: pointer;
    text-decoration-line: underline;
    text-underline-position: under;
    text-decoration-style: dashed;
}
h4.clickable {
    font-size: 14px;
}
td.clickable {
    color: #ca1f53;
}
td.clickable.active {
    color: #70b418;
}
td i {
    font-size: 16px;
    padding: 0 5px;
    color: #5d80b3;
    cursor: pointer;
}
@media (max-width: 1500px) {
    .user_promocode__container {
        padding: 0 15px;
    }
}
</style>
